import "./TableFooter.scss"
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";

interface TableFooterProps {
  page: number;
  totalItems: number;
  itemsPerPage: number;
  goToPage: (page: number) => void;
}

export default function TableFooter(props: TableFooterProps) {

  const { page, totalItems, itemsPerPage, goToPage } = props;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const firstItemShowing =
    totalItems === 0 ? 0 : (safePage - 1) * itemsPerPage + 1;
  const lastItemShowing = Math.min(safePage * itemsPerPage, totalItems);
  const goToSafePage = (targetPage: number) => {
    goToPage(Math.min(Math.max(targetPage, 1), totalPages));
  };
  const canGoBackOne = safePage > 1;
  const canGoBackTwo = safePage > 2;
  const canGoForwardOne = safePage < totalPages;
  const canGoForwardTwo = safePage + 1 < totalPages;

  return (
    <div className="table-footer">
      <div className="table-footer-text">
        Mostrando: {firstItemShowing}-{lastItemShowing} de {totalItems}
      </div>
      <div className="flex items-center">
        <button
          className={`footer-doubleArrow ${!canGoBackOne ? 'disabled' : ''}`}
          disabled={!canGoBackOne}
          onClick={() => goToSafePage(1)}
        >
          <MdKeyboardDoubleArrowLeft className="footer-icons" />
        </button>
        <button
          className={`footer-doubleArrow ${!canGoBackOne ? 'disabled' : ''}`}
          disabled={!canGoBackOne}
          onClick={() => goToSafePage(safePage - 1)}
        >
          <MdKeyboardArrowLeft className="footer-icons" />
        </button>

        <div
          className="mx-1 space-x-0.5 flex align-middle"
        >
          <button
            className={`page-button ${!canGoBackTwo ? 'disabled' : ''}`}
            disabled={!canGoBackTwo}
            onClick={() => goToSafePage(safePage - 2)}
          >
            {safePage - 2}
          </button>

          <button
            className={`page-button ${!canGoBackOne ? 'disabled' : ''}`}
            disabled={!canGoBackOne}
            onClick={() => goToSafePage(safePage - 1)}
          >
            {safePage - 1}
          </button>

          <button
            className="page-button focus"
            onClick={() => goToSafePage(safePage)}
          >
            {safePage}
          </button>

          <button
            className={`page-button ${!canGoForwardOne ? 'disabled' : ''}`}
            disabled={!canGoForwardOne}
            onClick={() => goToSafePage(safePage + 1)}
          >
            {safePage + 1}
          </button>

          <button
            className={`page-button ${!canGoForwardTwo ? 'disabled' : ''}`}
            disabled={!canGoForwardTwo}
            onClick={() => goToSafePage(safePage + 2)}
          >
            {safePage + 2}
          </button>
        </div>

        <button
          className={`footer-doubleArrow ${!canGoForwardOne ? 'disabled' : ''}`}
          disabled={!canGoForwardOne}
          onClick={() => goToSafePage(safePage + 1)}
        >
          <MdKeyboardArrowRight className="footer-icons" />
        </button>

        <button
          className={`footer-doubleArrow ${!canGoForwardOne ? 'disabled' : ''}`}
          disabled={!canGoForwardOne}
          onClick={() => goToSafePage(totalPages)}
        >
          <MdKeyboardDoubleArrowRight className="footer-icons" />
        </button>

      </div>
    </div>
  );
}
